import React from 'react';
import { TextFieldElement } from 'react-hook-form-mui';
import * as yup from 'yup';

export const adoptionPacketCatsSchema = {
  adoptionPacketLinkCats: yup.string().url('Adoption packet link must be a valid URL (including http:// or https://)'),
};

function AdoptionPacketsCatsPartial() {
  return (
    <TextFieldElement
      name="adoptionPacketLinkCats"
      sx={{ marginTop: 2 }}
      fullWidth
      label="Adoption packet for cats (optional)"
      variant="outlined"
      InputLabelProps={{ shrink: true }}
    />
  );
}

export default AdoptionPacketsCatsPartial;
